var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM5.52389 12.3778L4.83778 15.3389C4.81411 15.4471 4.81492 15.5593 4.84015 15.6672C4.86538 15.7751 4.9144 15.876 4.98361 15.9625C5.05283 16.049 5.1405 16.119 5.24023 16.1673C5.33995 16.2156 5.4492 16.241 5.56 16.2417C5.61163 16.2469 5.66365 16.2469 5.71528 16.2417L8.69444 15.5556L14.4144 9.85722L11.2222 6.67222L5.52389 12.3778ZM14.0822 4.87389L16.2128 7.00444C16.2826 7.07364 16.338 7.15591 16.376 7.24656C16.414 7.33721 16.4337 7.43445 16.434 7.53272C16.4343 7.631 16.4153 7.72837 16.378 7.81928C16.3406 7.91018 16.2857 7.99283 16.2164 8.0625L15.032 9.24694L11.8434 6.05833L13.0278 4.87389C13.1679 4.73452 13.3574 4.65629 13.555 4.65629C13.7526 4.65629 13.9422 4.73452 14.0822 4.87389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCircle);
export default __webpack_public_path__ + "static/media/pencil_circle.0574386b6a755aa1c2f914e4ba396658.svg";
export { ForwardRef as ReactComponent };